import React, { FC } from 'react'
import { StyledIcon, StyledIconProps } from '.'

export const PlugIcon: FC<StyledIconProps> = (props) => (
  <StyledIcon viewBox="0 0 19 18" {...props}>
    <g transform="translate(-2.000000, -2.000000)">
      <path
        d="M11.8851298,7.10757636 L11.8851298,2.71660616 C11.8851298,1.90736866 12.4386516,1.25134277 13.1214458,1.25134277 C13.8042399,1.25134277 14.3577617,1.90736866 14.3577617,2.71660616 L14.3577617,7.10757636 L16.8885368,7.10757636 L16.8885368,9.87645037 C16.8885368,13.022116 14.6586887,15.6463242 11.6950498,16.2517483 L11.6950498,21.1062291 C11.6950498,22.0006495 11.0832625,22.7257307 10.3285953,22.7257307 C9.57392813,22.7257307 8.96214083,22.0006495 8.96214083,21.1062291 L8.96214083,16.2260702 C6.05845559,15.5752204 3.88853675,12.9795567 3.88853675,9.87645037 L3.88853675,7.10757636 L6.48438103,7.10757636 L6.48438103,2.71660616 C6.48438103,1.90736866 7.03790287,1.25134277 7.72069701,1.25134277 C8.40349114,1.25134277 8.95701298,1.90736866 8.95701298,2.71660616 L8.95701298,7.10757636 L11.8851298,7.10757636 Z"
        transform="translate(10.388537, 11.988537) rotate(45.000000) translate(-10.388537, -11.988537) "
      />
    </g>
  </StyledIcon>
)

PlugIcon.displayName = 'PlugIcon'
